import { Box, Link as MuiLink, Tooltip, IconButton } from "@mui/material";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const CopyLink = ({ url, copied, setCopied }) => {

    const handleCopy = (text) => {
        navigator.clipboard.writeText(text).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 1500);
        });
    };

    return (
        <Box
            component="span"
            display="inline-flex"
            alignItems="center"
            sx={{ minWidth: 0, maxWidth: "100%", ml: 1 }}
        >
            <MuiLink
                href={url || "#"}
                color="text.primary"
                underline="hover"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                    display: "inline-block",
                    minWidth: 0,
                    maxWidth: 360,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    fontWeight: 600,
                }}
            >
                {url || "#"}
            </MuiLink>
            <Tooltip title={copied ? "Copié !" : "Copier"} arrow>
                <IconButton
                    size="small"
                    onClick={() => handleCopy(url)}
                    sx={{ ml: 0.5 }}
                >
                    <ContentCopyIcon fontSize="small" />
                </IconButton>
            </Tooltip>
        </Box>
    );
};

export default CopyLink;
